import
  React, {
  useState
} from 'react';

import {
  useHistory
} from 'react-router';

import {
  ColorSvg,
  HContainerVH,
  Image,
  Text,
  VContainer,
  VContainerVH,
  VFillContainer
} from '@vodacom/web-common';

import {
  Environment
} from '@vodacom/web-env';

import {
  BackButton,
  ModalCard,
  PrimaryButton
} from 'components';

import {
  getStorageWithExpiry,
  isEqual,
  setStorageWithExpiry
} from 'helpers';

import {
  EmergencyProvider
} from '../providers';

import {
  CustomColors,
  Icons
} from '../../../constants';

import {
  HandleRender
} from 'hocs';

export const EmergencySMS = props => {

  const BASE_URL = Environment.current.drupalBaseUrl;

  const history = useHistory();

  const [ state, setState ] = useState({
    showModal: false,
    claimedSMS: getStorageWithExpiry('Common', 'claimedSMS', false),
    userType: getStorageWithExpiry('msisdn', 'msisdnType', 'PREPAID'),
    isSuccess: null,
    message: null,
    error: null,
    loading: false
  });

  const provisionEmergencySMS = async () => {

    if (state?.claimedSMS === true) {
      return;
    }

    setState(prevState => ({
      ...prevState,
      loading: true
    }));

    const encMsisdn = getStorageWithExpiry('msisdn', 'encMsisdn', '');

    const response = await EmergencyProvider.provisionSMS(encMsisdn);

    if (!response.ok) {

      if (response?.code === 409) {

        setState(prevState => ({
          ...prevState,
          isSuccess: false,
          message: 'You have already claimed your 2 free sms for the day.',
          showModal: true
        }));

        setStorageWithExpiry('Common', 'claimedSMS', true, true);

        setState(prevState => ({
          ...prevState,
          claimedSMS: true,
          loading: false
        }));

        return;
      }

      setState(prevState => ({
        ...prevState,
        error: response?.error,
        loading: false
      }));

      return;
    }

    setState(prevState => ({
      ...prevState,
      isSuccess: true,
      message: 'Your 2 Free SMS\'s have been successfully allocated and will expire today at 23:59. Thank you for using the service. T&C\'s apply.',
      showModal: true,
      loading: false
    }));

    setStorageWithExpiry('Common', 'claimedSMS', true, true);

    setState(prevState => ({
      ...prevState,
      claimedSMS: true,
      loading: false
    }));

  };

  const buildToast = message => {

    return (

      <HContainerVH
        width={'80%'}
        margin={'1.5em auto'}
        boxShadow={`0px 5px 15px 0px ${CustomColors.TransparentBlack1}`}
        borderRadius={'4px'}>

        <ColorSvg
          src={Icons.WarningCircle}
          color={CustomColors.Red1}
          minWidth={'24px'}
          width={'24px'}
          height={'24px'}
          padding={'0 12px 0 16px'} />

        <Text
          fontSize={'14px'}
          padding={'16px 16px 16px 0'}>

          {message}
        </Text>

      </HContainerVH>
    );
  };

  const buildFooter = () => {

    return (
      <>
        { (isEqual(state?.userType, 'PREPAID') && state?.claimedSMS === true)
          ? buildToast('You have already claimed your 2 free sms for the day')
          : (state?.userType !== 'PREPAID')
            ? buildToast('Two Free SMS offer is only available to Vodacom Prepaid Customers')
            : <VContainerVH
                margin={'32px 0 75px'}>

                <PrimaryButton
                  text={'Get the offer'}
                  showSpinner={state.loading}
                  onClick={() => {
                    provisionEmergencySMS();
                  }}/>
              </VContainerVH>
        }
      </>
    );
  };

  return (

    <HandleRender
      isLoading={state.loading}
      isError={state.error}>

      { state.showModal &&

        <ModalCard
          isSuccess={state?.isSuccess}
          message={state?.message}
          pageName={`cbu: connectu: emergency sms ${state?.isSuccess ? 'success' : 'error'}`}
          onClose={() => {

            setState(prevState => ({
              ...prevState,
              showModal: false
            }));
          }}/>
      }

      <VContainer>

        <Image
          width={'100%'}
          height={'auto'}
          src={`${BASE_URL}${props.item?.image}`} />
      </VContainer>

      <BackButton
        onClick={() => history.goBack()} />

      <VFillContainer
        padding={'0 16px'} >

        <Text
          padding={'0'}
          fontSize={'20px'}
          fontWeight={'bold'}>
          {props.item?.title}
        </Text>

        <Text
          dangerouslySetInnerHTML={
            {
              __html: props.item?.full_content
            }
          } />
      </VFillContainer>

      {buildFooter()}
    </HandleRender>

  );
};